import { onAuthStateChanged, signOut } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { createContext, useContext, useEffect, useState } from "react";
import { auth, db } from "../firebase-key";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);          // Full user/team doc
  const [firebaseUser, setFirebaseUser] = useState(null); // Raw auth user
  const [userType, setUserType] = useState(null);  // "customer" | "team" | null
  const [loggedIn, setLoggedIn] = useState(false);
  const [loading, setLoading] = useState(true);

  // ---------------------------------------------------
  // 🔥 ON AUTH STATE CHANGE
  // ---------------------------------------------------
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      setFirebaseUser(currentUser);

      if (currentUser) {
        setLoggedIn(true);
        const uid = currentUser.uid;

        // -------- TRY FETCH FROM "users" (customer) --------
        const customerRef = doc(db, "users", uid);
        const customerSnap = await getDoc(customerRef);

        if (customerSnap.exists()) {
          setUser({
            uid,
            email: currentUser.email,
            ...customerSnap.data(),
          });
          setUserType("customer");
          setLoading(false);
          return;
        }

        // -------- TRY FETCH FROM "teams" --------
        const teamRef = doc(db, "teams", uid);
        const teamSnap = await getDoc(teamRef);

        if (teamSnap.exists()) {
          setUser({
            uid,
            email: currentUser.email,
            ...teamSnap.data(),
          });
          setUserType("team");
          setLoading(false);
          return;
        }

        // -------- If still nothing found --------
        setUser({
          uid,
          email: currentUser.email,
        });
        setUserType(null);
      } else {
        // Logged out
        setLoggedIn(false);
        setUser(null);
        setUserType(null);
      }

      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  // ---------------------------------------------------
  // 🔥 LOGOUT
  // ---------------------------------------------------
  const logout = async () => {
    await signOut(auth);
    setUser(null);
    setUserType(null);
    setLoggedIn(false);
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        firebaseUser,
        loggedIn,
        userType,   // <<------ NEW
        loading,
        logout,
      }}
    >
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
